<app-tabla
  [totalCount]="totalCount"
  [datos]="excepciones"
  [name]="name"
  [columnas]="columnas"
  [pageSizeOptions]="helper.pageSizeOptions"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [crear]="botonCrear"
  [emptyState]="{ title: 'Todavía no hay excepciones' }"
></app-tabla>
<!-- [search]="search" -->
